import { LogoExperiment } from '../../../Files/LogoExperiment';

export const BlockLogoExperiments = (props) => {
    const label = props.label;
    const path = props.item.path;
    const name = props.item.name;
    const route = props.item.route;
    const number = props.item.number;
    let src;
    switch (label) {
        case 'experiments':
            src = LogoExperiment(path);
            return (
                <div className="logo">
                    <a className="icon" href={route} alt={name}>
                        <img className="img" src={src} title={name} alt={name} loading="lazy" />
                    </a>
                    <div className="legend">
                        <div className="number">{number}</div>
                        <div className="title">{name}</div>
                    </div>
                </div>
            )
        case 'experiment':
            src = LogoExperiment(path);
            return (
                <div className="logo">
                    <div className="icon">
                        <img className="img" src={src} title={name} alt={name} loading="lazy" />
                    </div>
                    <div className="legend">
                        <div className="number">{number}</div>
                        <div className="title">{name}</div>
                        <div className="serie">{props.item.sname}</div>
                    </div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}